/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { ref, provide, onUpdated } from 'vue';

var TDisplayNoneElementRefresh = "t-display-none-element-refresh";
function useDestroyOnClose() {
  var refresh = ref(0);
  provide(TDisplayNoneElementRefresh, refresh);
  onUpdated(function () {
    refresh.value += 1;
  });
}

export { TDisplayNoneElementRefresh, useDestroyOnClose as default };
//# sourceMappingURL=useDestroyOnClose.mjs.map
